import "./Home.module.css";
import NavegaciNPrincipal from "@/reusable_sections/Header";
import ProtegemosLoQueMSImporta from "./sections/ProtegemosLoQueMSImporta";
import CompromisoConLaExcelencia from "./sections/CompromisoConLaExcelencia";
import SolucionesDeSeguridadIntegral from "./sections/SolucionesDeSeguridadIntegral";
import NuestrosPilaresTicos from "./sections/NuestrosPilaresTicos";
import VanguardiaTecnolGica from "./sections/VanguardiaTecnolGica";
import ConfianzaDeNuestrosClientes from "./sections/ConfianzaDeNuestrosClientes";
import InicieSuProtecciN from "./sections/InicieSuProtecciN";
import InformaciNCorporativa from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <NavegaciNPrincipal />
      <ProtegemosLoQueMSImporta />
      <CompromisoConLaExcelencia />
      <SolucionesDeSeguridadIntegral />
      <NuestrosPilaresTicos />
      <VanguardiaTecnolGica />
      <ConfianzaDeNuestrosClientes />
      <InicieSuProtecciN />
      <InformaciNCorporativa />
    </div>;
}